import React from 'react'
import MenuItem from '@material-ui/core/MenuItem';

import { SelectInput } from '.'

export const ChoicesSelectInput = (props) => (
    <SelectInput {...props}>
        {props.choices.map(choice => (
            <MenuItem key={choice.value} value={choice.value}>{choice.name}</MenuItem>
        ))}
    </SelectInput>
)
